import React from 'react';
import ErrorBoxLayout from '../errors/ErrorBoxLayout';
import ErrorInfoView from '../errors/ErrorInfoView';
import { ErrorCode } from '../errors/types';

export default function AppsListUnauthorizedView() {
  return (
    <ErrorBoxLayout>
      <ErrorInfoView code={ErrorCode.Unauthorized} />
    </ErrorBoxLayout>
  );
}
